export const business = {
  name: "Chavel Saraiva Ltda",
  brand: "Chavel Chaveiro",
  shortName: "Chavel",
  since: 1975,
  street: "Av. Amazonas, 1354 - Lj 01",
  neighborhood: "Brasiléia",
  city: "Betim",
  region: "MG",
  regionName: "Minas Gerais",
  postalCode: "32600-324",
  phone: "(31) 3531-3544",
  phoneRaw: "+553135313544",
  whatsapp: "553135313544",
  email: "contato@chavelbetim.com.br",
  rating: 4.5,
  reviewCount: 55,
  latitude: -19.9689,
  longitude: -44.1983,
  mapsUrl:
    "https://www.google.com/maps/dir//Chavel+Saraiva+Ltda,+Av.+Amazonas,+1354+-+Lj+01+-+Brasil%C3%A9ia,+Betim+-+MG,+32600-324/@-19.9421081,-44.1923033,12z/data=!3m1!4b1!4m8!4m7!1m0!1m5!1m1!1s0xa6c384c13388b1:0xbc544190a7ee6932!2m2!1d-44.2034921!2d-19.9697907?hl=pt-BR&entry=ttu",
  mapsEmbedUrl:
    "https://www.google.com/maps?q=Chavel+Saraiva+Ltda,+Av.+Amazonas,+1354+-+Lj+01+-+Brasil%C3%A9ia,+Betim+-+MG,+32600-324&hl=pt-BR&z=16&output=embed",
  hours: [
    { day: "Segunda-feira", value: "08:00 – 18:00" },
    { day: "Terça-feira", value: "08:00 – 18:00" },
    { day: "Quarta-feira", value: "08:00 – 18:00" },
    { day: "Quinta-feira", value: "08:00 – 18:00" },
    { day: "Sexta-feira", value: "08:00 – 18:00" },
    { day: "Sábado", value: "08:00 – 13:00" },
    { day: "Domingo", value: "Fechado" },
  ],
  schemaHours: [
    { days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "08:00", closes: "18:00" },
    { days: ["Saturday"], opens: "08:00", closes: "13:00" },
  ],
  neighborhoods: [
    "Centro",
    "Brasiléia",
    "Alterosa",
    "Angola",
    "Guarujá",
    "Ingá",
    "Dom Bosco",
    "Jardim Teresópolis",
    "Icaivera",
    "PTB",
    "Bandeirinhas",
    "Vianópolis",
    "Citrolândia",
    "Petrovale",
    "Amazonas",
    "Niterói",
    "São Caetano",
    "Laranjeiras",
  ],
} as const;

export const fullAddress = `${business.street} - ${business.neighborhood}, ${business.city} - ${business.region}, ${business.postalCode}`;

export function waLink(message: string) {
  return `https://wa.me/${business.whatsapp}?text=${encodeURIComponent(message)}`;
}

/** Cupom de desconto usado na mensagem inicial do WhatsApp. */
export const WHATSAPP_COUPON = "CHAVEL2026";

/** Mensagem pronta enviada ao abrir o WhatsApp (o cupom evita que o lead apague o texto). */
export const WHATSAPP_MESSAGE = [
  "Olá, Chavel! 🔑",
  "",
  `Vim pelo site e quero usar o CUPOM DE DESCONTO: *${WHATSAPP_COUPON}*`,
  "",
  "Gostaria de um orçamento para atendimento de chaveiro.",
].join("\n");

export const whatsappHref = waLink(WHATSAPP_MESSAGE);
